module.exports = __webpack_public_path__ + "img/Petite Fille.6e743b7a.png";